<template>
<v-flex offset-md1 md10 mb-5>
  <v-layout row wrap class="border-content mt-5 pa-4 mb-5">
    <v-flex sm12 mb-5 >
      <div class="company-header">
        Avaliações
      </div>
      <table class="tb-evaluations" cellspacing="0" cellspadding="0">
          <thead>
              <tr>
                  <th>Data</th>
                  <th>Cliente</th>
                  <th>Item</th>
                  <th>Nota</th>
                  <th>Comentário</th>
                  <th>Resposta</th>
                  <th></th>
              </tr>
          </thead>
          <tbody>
              <tr v-for="item in evaluations" :key="item.id">
                <td>{{ item.data | formatDate }}</td>
                <td>{{ item.usuario }}</td>
                <td>{{ item.item }}</td>
                <td>{{ item.nota }}</td>
                <td>{{ item.comentario }}</td>
                <td>{{ item.resposta }}</td>
                <td>
                    <v-btn icon flat color="grey lighten-1" slot="activator" @click.native.stop="responder(item.id)">
                    <v-icon>create</v-icon>
                    </v-btn>
                </td>
              </tr>
          </tbody>
      </table>
    </v-flex>
    <v-flex d-flex sm3>
        <v-layout row wrap>
          <v-flex sm6>
            <div class="v-subheader theme--light">itens por página</div>
          </v-flex>
          <v-flex sm6>
            <v-select
              single-line
              :value="itemsPerPage"
              bottom
              required
              v-model="ipp"
              v-bind:items="comboList"
              @change="refreshList"
            >
            </v-select>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex d-flex sm6>
        <v-layout row wrap justify-center>
          <p class="pt-3 pr-2 mb-0">{{pagingText}}</p>
        </v-layout>
      </v-flex>
      <v-flex d-flex sm3>
        <v-layout row wrap justify-end>
          <v-btn
              fab
              rounded
              outlined
              small
              @click.native="prev"
              v-show="currentPage > 1"
              >
                <v-icon light>arrow_back</v-icon>
          </v-btn>
          <v-btn
            fab
            rounded
            outlined
            small
            v-show="currentPage < totalPages"
            @click.native="next"
            >
              <v-icon light>arrow_forward</v-icon>
          </v-btn>
        </v-layout>
      </v-flex>
  </v-layout>
  <AvaliacaoResposta />
  <v-layout row wrap>
      
    </v-layout>
    </v-flex>
</template>
<script>
import AvaliacaoResposta from './avaliacaoResposta'

export default {
  name: 'Avaliações',
  components: {
    AvaliacaoResposta
  },
  data () {
    return {
      comboList: [6, 12, 18, 24, 30],
      ipp: 12
    }
  },
  methods: {
    next () {
      this.$store.commit('nextPage')
      this.$store.dispatch('getEvaluations')
    },
    prev () {
      this.$store.commit('prevPage')
      this.$store.dispatch('getEvaluations')
    },
    refreshList () {
      this.$store.commit('changeItemsPerPage', this.ipp)
      this.$store.dispatch('getEvaluations')
    },
    responder (item) {
      this.$store.commit('selectAvaliacao', item)
    }
  },
  computed: {
    pagingText () {
      return `mostrando de ${((this.$store.getters.currentPage - 1) * this.$store.getters.itemsPerPage + 1)} a ${((this.$store.getters.currentPage * this.$store.getters.itemsPerPage) > this.$store.getters.totalItems ? this.$store.getters.totalItems : (this.$store.getters.currentPage * this.$store.getters.itemsPerPage))} de ${this.$store.getters.totalItems}`
    },
    evaluations () {
      return this.$store.getters.evaluations
    },
    currentPage () {
      return this.$store.getters.currentPage
    },
    itemsPerPage () {
      return this.$store.getters.itemsPerPage
    },
    totalPages () {
      return this.$store.getters.totalPages
    }
  },
  mounted () {
    this.$store.commit('resetPage')
    this.$store.dispatch('getEvaluations')
  }
}
</script>
<style>
.tb-evaluations{width: 100%; border-collapse: collapse;}
.tb-evaluations thead th{text-align:left;padding:5px;}
.tb-evaluations tbody td{padding:5px;}
.tb-evaluations thead tr{border-bottom: 1px solid #999}
.tb-evaluations tbody tr{border-bottom: 1px solid #ddd}

</style>



// WEBPACK FOOTER //
// avaliacoes.vue?14263f66